
import { pipe } from '@/lib/utils'

import { applyStatisticsTransformation } from './statistics'
import { applyStockLevelTransformation } from './stockLevels'

import type { Shelf, TransformedShelf } from '../types'
import type { StockLevelMapper } from '@utils/stockLevelMapper'

/**
 * Default shelf transformation that applies all standard transformations in the correct order.
 *
 * This is the recommended way to transform a shelf for most use cases.
 * It applies:
 * 1. Geometric transformation (ShelfDTO → TransformedShelf)
 * 2. Stock level mapping (TransformedShelf → TransformedShelf)
 * 3. Statistics calculation (TransformedShelf → Shelf)
 *
 * @param shelf - The raw shelf DTO from the API
 * @param stockLevelMapper - Stock level mapper (optional, only applied if provided)
 * @returns Fully transformed shelf ready for rendering
 */
export function shelfDtoToWrapperPipeline(
  shelf: TransformedShelf,
  stockLevelMapper: StockLevelMapper
): Shelf {
  return pipe(
    shelf,
    s => applyStockLevelTransformation(s, stockLevelMapper),
    s => applyStatisticsTransformation(s, stockLevelMapper.isHidingUnknown)
  )
}
